import { cloneDeep } from 'lodash'
import { ISSUE } from '.'
import { ISSUE_STATUS_VALUE, OTHER, convertArrayToHashMapByKey } from '../../helpers'
import apiService from '../apiService'
import { LOADER } from '../Loader'

export const setFacilityHashMap = () => {
  return (dispatch, getState) => {
    const { detailRoom } = getState().roomReducer
    if (!detailRoom) return
    const { facility } = detailRoom
    const facilityHashMap = convertArrayToHashMapByKey(facility, 'itemId')

    dispatch({
      type: ISSUE.actionType.SET_FACILITY_HASH_MAP,
      data: { facilityHashMap }
    })
  }
}

export const createIssue = (roomId, func = () =>{}) => {
  return async (dispatch, getState) => {
    const issueReducer = getState().issueReducer
    dispatch(LOADER.action.displayLoader(true))

    const issueRawData = {
      roomId,
      images: issueReducer.imageFile,
      detail: issueReducer.issueDetail,
      status: ISSUE_STATUS_VALUE.PENDING,
      itemId: issueReducer.selectedItemId,
    }

    if (issueRawData.itemId === OTHER) {
      issueRawData.itemId = null
    }
  
    const response = await apiService.postFormData('rest/v2/issue/create', issueRawData)
    
    return response
  }
}

export const deleteSelectedItem = (index) => {
  return (dispatch, getState) => {
    const renderImages = cloneDeep(getState().issueReducer.renderImages)
    const imageFile = cloneDeep(getState().issueReducer.imageFile)

    imageFile.splice(index, 1)
    renderImages.splice(index, 1)

    dispatch(setUploadImages(imageFile, renderImages))
  }
}

export const setSelectedItem = (itemId, itemName) => dispatch => {
  dispatch({
    type: ISSUE.actionType.SET_SELECTED_ITEM,
    data : { selectedItemId: itemId, selectedItemName : itemName }
  })
}

export const setIssueDetail = (issueDetail) => dispatch => {
  dispatch({ type: ISSUE.actionType.SET_ISSUE_DETAIL, data: { issueDetail } })
}

export const addUploadImages = (resultFile, resultImage) => (dispatch) => {
  dispatch({
    type: ISSUE.actionType.ADD_UPLOAD_IMAGE,
    data: {
      imageFile: resultFile,
      renderImages: { image: resultImage, name: resultFile.name }
    },
  })
}

export const setUploadImages = (imageFile, renderImages) => dispatch => {
  dispatch({
    type: ISSUE.actionType.SET_UPLOAD_IMAGE,
    data: { imageFile, renderImages }
  })
}

export const clearIssue = () => dispatch => {
  dispatch({ type: ISSUE.actionType.CLEAR_ISSUE })
}
